export const Delivery = () => {
	return (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="0.5" width="24" height="24" rx="4" fill="#20AC93" />
			<path
				d="M11.4619 20.0176C12.0115 20.6602 12.9885 20.6602 13.5381 20.0176L19.2676 13.3174C19.7723 12.7272 19.4036 11.7317 18.5596 11.7314H16.8994C16.2219 11.7314 15.6399 11.1546 15.6396 10.4023V7.6582C15.6396 6.8954 15.0399 6.24417 14.2598 6.24414H10.7402C9.96014 6.24417 9.36037 6.8954 9.36035 7.6582V10.4023C9.36012 11.1546 8.77812 11.7314 8.10059 11.7314H6.44043C5.5964 11.7317 5.22768 12.7272 5.73242 13.3174L11.4619 20.0176Z"
				fill="#20AC93"
				stroke="white"
				strokeLinecap="round"
			/>
		</svg>
	);
};
